export interface NewsItem {
  id: string;
  slug: string;
  title: string;
  date: string;
  tag: string;
  excerpt: string;
  content: string;
  keyTakeaways?: string[];
  relatedEvents?: string[];
  relatedOpportunities?: string[];
}

export const news: NewsItem[] = [
  {
    id: '1',
    slug: 'bcbh-mou-signed',
    title: 'BCBH MoU Signed: Launch of Korea–Egypt Business Hub',
    date: '2025-03-26',
    tag: 'Announcement',
    excerpt: 'BTEC, LOHMANN ECCE, and BTP officially launch the BUSAN–CAIRO BUSINESS HUB (BCBH) with the signing of a Memorandum of Understanding.',
    content: `The BUSAN–CAIRO BUSINESS HUB (BCBH) was officially launched on March 26, 2025, with the signing of a Memorandum of Understanding between BUSAN TECHNOPARK ENTERPRISE COUNCIL (BTEC), LOHMANN ECCE for Infrastructure & Clean Energy S.A.E., and BUSAN TECHNOPARK (BTP).

The MoU establishes BCBH as a platform for facilitating business connections, knowledge exchange, and project opportunities between Korea and Egypt. The hub will operate offices in both Cairo and Busan, enabling regular meetings and coordination between Korean and Egyptian companies.

Key objectives include:
- Regular business tie-ups between companies in Korea and Egypt
- Know-how exchange and training programs
- Joint venture tender cooperation
- Technology transfer and capacity building

BCBH represents a significant step forward in strengthening economic ties between Korea and Egypt, providing a structured platform for companies from both countries to explore collaboration opportunities.`,
    keyTakeaways: [
      'BCBH officially launched on March 26, 2025',
      'Three founding partners: BTEC, LOHMANN ECCE, and BTP',
      'Offices planned in Cairo and Busan',
      'Focus on business matchmaking, training, and JV cooperation',
    ],
    relatedEvents: ['bcbh-launch-ceremony'],
    relatedOpportunities: [],
  },
  {
    id: '2',
    slug: 'first-networking-event-cairo',
    title: 'First BCBH Networking Event Held in Cairo',
    date: '2025-04-05',
    tag: 'Event',
    excerpt: 'BCBH hosted its first networking reception in Cairo, bringing together Korean and Egyptian business representatives.',
    content: `BCBH successfully hosted its first networking reception in Cairo on April 5, 2025. The event brought together representatives from Korean and Egyptian companies, providing an opportunity for initial introductions and relationship building.

Attendees included companies from various sectors including infrastructure, technology, and industrial products. The reception featured brief updates on BCBH activities and upcoming events, followed by informal networking sessions.

The event demonstrated strong interest from both Korean and Egyptian companies in exploring collaboration opportunities through BCBH.`,
    keyTakeaways: [
      'First networking event successfully held',
      'Strong attendance from Korean and Egyptian companies',
      'Positive feedback on BCBH platform',
    ],
    relatedEvents: ['cairo-networking-reception'],
    relatedOpportunities: [],
  },
  {
    id: '3',
    slug: 'technology-forum-announced',
    title: 'Korea–Egypt Technology Exchange Forum Announced',
    date: '2025-04-15',
    tag: 'Event',
    excerpt: 'BCBH announces upcoming Technology Exchange Forum in Busan, focusing on innovation partnerships.',
    content: `BCBH has announced the Korea–Egypt Technology Exchange Forum, scheduled for May 15, 2025 in Busan, South Korea. The forum will focus on technology transfer, innovation partnerships, and collaboration opportunities between Korean and Egyptian tech companies.

The event will feature keynote presentations, panel discussions, company presentations, and B2B matchmaking sessions. Both Korean and Egyptian technology companies are invited to participate.

The forum aims to facilitate connections between companies seeking technology partnerships, joint R&D opportunities, and market expansion in both countries.`,
    keyTakeaways: [
      'Technology forum scheduled for May 15, 2025',
      'Focus on innovation and technology transfer',
      'B2B matchmaking included',
    ],
    relatedEvents: ['korea-egypt-tech-forum'],
    relatedOpportunities: [],
  },
  {
    id: '4',
    slug: 'wastewater-webinar-update',
    title: 'Wastewater Management Solutions Webinar Scheduled',
    date: '2025-05-20',
    tag: 'Event',
    excerpt: 'BCBH announces virtual webinar on wastewater treatment technologies and market opportunities.',
    content: `BCBH will host a virtual webinar on June 10, 2025, focusing on wastewater management solutions and opportunities for Korean technologies in the Egyptian market.

The webinar will provide an overview of the Egyptian wastewater treatment market, showcase Korean technologies and solutions, and include a Q&A session for participants.

This event is part of BCBH's sector-specific focus, connecting Korean solution providers with Egyptian market opportunities.`,
    keyTakeaways: [
      'Virtual webinar scheduled for June 10',
      'Focus on wastewater treatment solutions',
      'Market opportunities in Egypt',
    ],
    relatedEvents: ['wastewater-solutions-webinar'],
    relatedOpportunities: [],
  },
  {
    id: '5',
    slug: 'membership-waitlist-opens',
    title: 'BCBH Membership Waitlist Now Open',
    date: '2025-04-01',
    tag: 'Announcement',
    excerpt: 'BCBH opens membership waitlist for companies interested in joining the hub when Phase 2 launches.',
    content: `BCBH has opened its membership waitlist for companies interested in joining the hub when Phase 2 launches. The membership program will provide access to exclusive features including:

- Tenders database and alerts
- Business Opportunities Exchange
- Member directory
- Event RSVP and attendance management
- Publications and briefings library
- Training and recruitment programs

Companies can register their interest through the BCBH website. Membership details and pricing will be announced closer to Phase 2 launch.`,
    keyTakeaways: [
      'Membership waitlist now open',
      'Phase 2 features previewed',
      'Registration available on website',
    ],
    relatedEvents: [],
    relatedOpportunities: [],
  },
  {
    id: '6',
    slug: 'infrastructure-workshop-success',
    title: 'Infrastructure Development Workshop Successfully Completed',
    date: '2025-04-22',
    tag: 'Event',
    excerpt: 'BCBH hosted a successful workshop on infrastructure projects and joint venture opportunities.',
    content: `BCBH successfully hosted an Infrastructure Development Workshop in Cairo on April 20, 2025. The workshop brought together Korean and Egyptian companies interested in infrastructure projects, tenders, and joint venture opportunities.

The event featured project presentations, an overview of the tender process in Egypt, and guidance on forming joint ventures. Participants had the opportunity to network and explore potential collaborations.

The workshop demonstrated strong interest in infrastructure collaboration between Korean and Egyptian companies, with several follow-up meetings scheduled.`,
    keyTakeaways: [
      'Workshop successfully completed',
      'Strong interest in infrastructure projects',
      'Follow-up meetings scheduled',
    ],
    relatedEvents: ['infrastructure-workshop'],
    relatedOpportunities: [],
  },
];

